import { ControlValueAccessor, FormControl } from '@angular/forms';

export class FormField implements ControlValueAccessor {
  public inputValue = '';
  public disabled = false;
  public control: FormControl = new FormControl();

  get value(): string {
    return this.inputValue;
  }

  // sets the value used by the ngModel of the element
  set value(val: string) {
    this.inputValue = val;
    this.onChange(val);
    this.onTouch(val);
  }

  onChange: (_: unknown) => void = () => ({});
  onTouch: (_: unknown) => void = () => ({});

  /**
   * This will will write the value to the view if the the value changes occur on the model programmatically
   * @param value
   */
  writeValue(value: string) {
    this.value = value;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // When the value in the UI is changed, this method will invoke a callback function
  registerOnChange(fn: (_: unknown) => void) {
    this.onChange = fn;
  }

  // When the element is touched, this method will get called
  registerOnTouched(fn: (_: unknown) => void) {
    this.onTouch = fn;
  }
}
